import type React from 'react';

import {
  ScCustomArrowLeft,
  ScCustomArrowRight,
  ScCustomArrows,
} from './styled';

interface ICustomArrowsProps {
  componentLeft: React.ReactNode;
  componentRight: React.ReactNode;
  handlePrevClick: () => void;
  handleNextClick: () => void;
}

export const CustomArrows = ({
  componentLeft,
  componentRight,
  handlePrevClick,
  handleNextClick,
}: ICustomArrowsProps) => (
  <ScCustomArrows>
    <ScCustomArrowLeft onClick={handlePrevClick}>
      {componentLeft}
    </ScCustomArrowLeft>
    <ScCustomArrowRight onClick={handleNextClick}>
      {componentRight}
    </ScCustomArrowRight>
  </ScCustomArrows>
);
